import { createTheme, PaletteColor } from '@mui/material/styles';
import { ptBR } from '@mui/material/locale';

const PRIMARY_TEXT_CONTRAST = "#FFFFFF";
const PRIMARY = "#00a335";
const PRIMARY_LIGHT = "#33b55d";
const PRIMARY_DARK = "#007225";

const SECONDARY_TEXT_CONTRAST = "#FFFFFF";
const SECONDARY = "#757575";
const SECONDARY_LIGHT = "#7393a1";
const SECONDARY_DARK = "#385460";

const ERROR_TEXT_CONTRAST = "#FFFFFF";
const ERROR = "#b91222";
const ERROR_LIGHT = "#c7414e";
const ERROR_DARK = "#810c17";

const INFO_TEXT_CONTRAST = "#FFFFFF";
const INFO = "#00a195";
const INFO_LIGHT = "#33b3aa";
const INFO_DARK = "#007068";

const WARNING_TEXT_CONTRAST = "#FFFFFF";
const WARNING = "#EAB42A";
const WARNING_LIGHT = "#eec354";
const WARNING_DARK = "#a37d1d";

const PRIMARY_PALETTE: PaletteColor = {
  contrastText: PRIMARY_TEXT_CONTRAST,
  main: PRIMARY,
  dark: PRIMARY_DARK,
  light: PRIMARY_LIGHT,
};

const SECONDARY_PALETTE: PaletteColor = {
  contrastText: SECONDARY_TEXT_CONTRAST,
  main: SECONDARY,
  dark: SECONDARY_DARK,
  light: SECONDARY_LIGHT,
};

const ERROR_PALETTE: PaletteColor = {
  contrastText: ERROR_TEXT_CONTRAST,
  main: ERROR,
  dark: ERROR_DARK,
  light: ERROR_LIGHT,
};

const INFO_PALETTE: PaletteColor = {
  contrastText: INFO_TEXT_CONTRAST,
  main: INFO,
  dark: INFO_DARK,
  light: INFO_LIGHT,
};

const WARNING_PALETTE: PaletteColor = {
  contrastText: WARNING_TEXT_CONTRAST,
  main: WARNING,
  dark: WARNING_DARK,
  light: WARNING_LIGHT,
};

const theme = createTheme(
  {
    palette: {
      primary: PRIMARY_PALETTE,
      secondary: SECONDARY_PALETTE,
      error: ERROR_PALETTE,
      info: INFO_PALETTE,
      warning: WARNING_PALETTE,
    },
  },
  ptBR
);

export default theme;
